export default __webpack_public_path__ + "static/media/G03CCI.98712dfa.jpg";